import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import './Header.css'

function Header() {
  const location = useLocation()
  const navigate = useNavigate()
  const isLegalPage = location.pathname === '/privacy' || location.pathname === '/terms'
  const isHomePage = location.pathname === '/'

  // 处理页面加载后的锚点滚动
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }
  }, [location])

  // 处理锚点链接点击
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault()
    
    if (isHomePage) {
      // 如果在首页，直接滚动到锚点
      const element = document.querySelector(anchor)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      // 如果在其他页面，先导航到首页，再滚动
      navigate('/' + anchor)
    }
  }

  return (
    <header className={isLegalPage ? 'header-compact' : ''}>
      <nav>
        <Link to="/" className="logo">
          <div className="logo-icon">镜</div>
          TradeMirror
        </Link>
        <ul className="nav-links">
          <li><Link to="/">首页</Link></li>
          <li>
            <a href="#features" onClick={(e) => handleAnchorClick(e, '#features')}>
              功能
            </a>
          </li>
          <li>
            <a href="#pricing" onClick={(e) => handleAnchorClick(e, '#pricing')}>
              定价
            </a>
          </li>
          <li><Link to="/privacy">隐私协议</Link></li>
          <li><Link to="/terms">用户协议</Link></li>
        </ul>
        <button className="mobile-menu-btn" aria-label="菜单">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </nav>
    </header>
  )
}

export default Header
